var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.863 18.902-5.687 8.431c.883.295 10.785-3.725 12.844-5.686 2.058-1.96 2.745-4.51 2.45-6.274-.293-1.765-.784-3.53.295-5.393 1.078-1.862 2.45-2.058 3.431-2.45.784-.314 3.53-.785 4.804-.98-.294-.132-1.157-.374-2.255-.295-1.373.098-3.235.686-4.902.98-1.667.294-2.353-.784-4.215 0-1.863.785-2.06 2.353-2.256 3.334-.156.783-.718 2.352-.98 3.038-.817-.392-3.47-1.53-7.549-2.941C4.765 9.255 1.915 9.033 1 9.097c1.797 1.93 6.275 6.236 9.804 8.04 3.53 1.804 5.98 1.013 6.765.392a7.99 7.99 0 0 1-1.57 1.176c-.706.392-2.386.294-3.137.196z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.863 10.569c.314 1.41 2.222 2.156 3.137 2.352-.098-.98-.373-3.334-.686-4.902C15 6.45 13.876 4.686 13.353 4c-.294 1.601-.804 5.157-.49 6.569z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsw);
export default __webpack_public_path__ + "static/media/BSW.5556c7addaf08497098957cae71d4e5b.svg";
export { ForwardRef as ReactComponent };